import printJS from "print-js";
import moment from "moment";

class Printer {
  constructor() {
    this.print = this.print.bind(this);
  }

  print(gameID, data, playersCount) {
    const { id, created, amount, balls, address } = data;

    // Calcul du gain potentiel
    const payout_matrix = [
    [0,   0,    0,    0,    0,     0,     1,     1,     2,     2],   
    [3,   1,    0,    0,    0,     0,     0,     0,     0,     0],   
    
    [0,  10,    2,    1,    1,     0,     0,     0,     0,     0],   
    
    [0,   0,   45,   10,    3,     2,     2,     0,     0,     0],   
    
    [0,   0,    0,   80,   20,    15,     4,     5,     2,     0],   
    
    [0,   0,    0,    0,  150,    60,    20,    15,    10,     5],   
    
    [0,   0,    0,    0,    0,   500,    80,    50,    25,    30],   
    
    [0,   0,    0,    0,    0,    0,    1000,   200,   125,  100],
    
    [0,   0,    0,    0,    0,     0,      0,  2000,   1000,  300],   
    [0,   0,    0,    0,    0,     0,     0,     0,   5000,  2000],   
    [0,   0,    0,    0,    0,     0,     0,     0,     0,  10000]     
]



    // Nombre de boules sélectionnées
    const ballsSelected = balls.length;
    
    // Récupérer le coefficient de gain à partir de la matrice
    const payoutMultiplier = payout_matrix[ballsSelected][ballsSelected - 1];

    // Calcul du gain potentiel
    const potentialWin = amount * payoutMultiplier;

    const desk = `immaculeeparyaj.com ${playersCount}`;
    const startDate = created;

    const htmlContent = `
      <div style="display: flex; justify-content: center;">
        <div style="font-family: 'Courier New', Courier, monospace; font-size: 16px; width: 380px; text-align: left;">
          <div style="text-align: center; font-size: 24px; margin-bottom: 5px;font-weight: bold;">Keno (Immaculée pariage)</div>
          <div class="separator" style="border-bottom: 1px solid black; margin-bottom: 5px;"></div>
          
          <div style="margin-bottom: 5px;">
            <div><strong>ROUND ID: ${gameID}</strong></div>
            <div><strong>Ticket ID: ${id}</strong></div>
            <div><strong>Date Création: ${startDate}</strong></div>
            <div><strong>Adresse: ${address || ""}</strong></div>
          </div>
          
          <div class="separator" style="border-bottom: 1px solid black; margin-bottom: 5px;"></div>

          <div style="margin-bottom: 5px;">
            <div><strong>Boules : ${balls.join(",")}</strong></div>
            <div><strong>Mise : ${amount} HTG</strong></div>
            <div><strong>Potentielle Gain : ${potentialWin} HTG</strong></div>
          </div>
        </div>
      </div>
    `;

    printJS({
      printable: htmlContent,
      type: "raw-html",
      style: `
        .separator { border-bottom: 1px solid black; margin: 5px 0; }
        img { width: 100%; height: 50px; margin-top: 5px; }
        body { margin: 0; }
      `,
    });
  }
}

export default Printer;


